import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import { BaseURL,  uniqueToken } from "../../api/DataApis";
import {GpsBaseURL} from "../../api/DataApis";
import axios from "axios";
import Select from 'react-select';
import Loader from "../Settings/Loader";


function Edit() {
  document.title = "Corporate | Edit";
  let navigate = useNavigate();
  let params = useParams();
  let CorporateID = params?.cid;
  //  let CorporateEditData = location?.state?.CorporateEditData;

  //  console.log("CorporateEditData", CorporateEditData);


  // State variables
  const [Name, setName] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState("");
  const [PanNumber, setPanNumber] =  useState("");
  const [BankName, setBankName] =  useState("");
  const [loading, setLoading] = useState(false);
  const [PhoneCode, setPhoneCode] =  useState("");
  const [slug, setSlug] =  useState("");
  const [Logo, setLogo] =  useState(null);
  const [Password, setPassword] =  useState("");
    const [AdminImage, setAdminImage] =  useState("");
    const [CorporateEditData, setCorporateEditData] = useState([]);

  const handleName = (e) => setName(e.target.value);
  const handleMobileChange = (e) => setMobile(e.target.value);
  const handleMobileCodeChange = (e) => setPhoneCode(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePanNumberChange = (e)   => setPanNumber(e.trarget.value);
  const handleBankNameChange =  (e) =>  setBankName(e.target.value);
  const handleSlug = (e) => setSlug(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleImageChange = (e) => setAdminImage(e.target.files[0]);
  
  const handleLogoChange = (e) => {
    setLogo(e.target.files[0]); // Set the first file from the input
  };

  useEffect(() => {
    const fetchCorporateEditData = async () => {
      setLoading(true);
      const apiEndpoint = `${GpsBaseURL}/corporate/${CorporateID}`;
      try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("Countries response", response);
        setCorporateEditData(response.data.data[0]);
      } catch (error) {
        console.error("Error fetching countries:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCorporateEditData();
  }, []);


    useEffect(() => {
      // Ensure CategoryEditData is populated and master_select_power_id exists before running the logic
      if (CorporateEditData) {
        setName(CorporateEditData?.name);
        setEmail(CorporateEditData?.email);
        setBankName(CorporateEditData?.corporate_name);
        setPanNumber(CorporateEditData?.pan_number);
        setPassword(CorporateEditData?.password);
        setMobile(CorporateEditData?.phone);
        setPhoneCode(CorporateEditData?.phone_code);
        setSlug(CorporateEditData?.slug)
      }
    }, [CorporateEditData]);
  // Function to handle the update request
  const UpdateUser = async () => {
    // Show loader before API call
    Swal.fire({
      title: 'Updating User...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    // Create a new FormData object
    let formData = new FormData();
    formData.append("name", Name);
    if(Mobile) {
    formData.append("phone", Mobile);
    }
    if(Email) {
    formData.append("email", Email);
    }
    if(BankName) {
    formData.append("corporate_name", BankName);
    }
    if(Password) {
    formData.append("password", Password);
    };
    if(PanNumber) {
    formData.append("pan_number", PanNumber);
    }
    formData.append("slug", slug);
    if(PhoneCode) {
    formData.append("phone_code", PhoneCode);
    }
    if(Logo) {
    formData.append("logo", Logo);
    }
    if(AdminImage) {
      formData.append("admin_image", AdminImage);
    }

 
    try {
      // Make the API request
      let response = await axios.put(
        `${GpsBaseURL}/corporate/${CorporateEditData?._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
            // 'Content-Type' is automatically set by axios when using FormData
          },
        }
      );
  
      // Hide the loader
      Swal.close();
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "User updated successfully...",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/corporate/list`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to update station. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      // Hide the loader
      Swal.close();
  
      console.error("Error in AddUser:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };

  return (
    <>
    {loading ? (
   <Loader />
 ) : (
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Add Corporate
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="name_id" className="col-sm-2 control-label">
                            Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleName}
                                value={Name}
                                className="form-control"
                                id="name_id"
                                name="station_name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                   

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Enter Email
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="email"
                                onChange={handleEmailChange}
                                className="form-control"
                                id="email"
                                name="email"
                                value={Email}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Corporate Name
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="email"
                                onChange={handleBankNameChange}
                                className="form-control"
                                id="email"
                                name="email"
                                value={BankName}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              PAN Number
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="email"
                                onChange={handlePanNumberChange}
                                className="form-control"
                                id="email"
                                name="email"
                                value={PanNumber}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Slug
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="text"
                                onChange={handleSlug}
                                className="form-control"
                                id=""
                                name=""
                                value={slug}
                                autoComplete="off"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Password
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="password"
                                onChange={handlePasswordChange}
                                className="form-control"
                                id="password"
                                name="password"
                                value={Password}
                                autoComplete="new-password"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="latitude_id" className="col-sm-2 control-label">
                              Mobile
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMobileChange}
                                className="form-control"
                                id="latitude_id"
                                name="latitude"
                                value={Mobile}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                          <div className="form-group">
                          <div className="row">
                            <label htmlFor="latitude_id" className="col-sm-2 control-label">
                              Mobile Code
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMobileCodeChange}
                                className="form-control"
                                id="latitude_id"
                                name="latitude"
                                value={PhoneCode}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="latitude_id" className="col-sm-2 control-label">
                             Logo
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="file"
                                onChange={handleLogoChange}
                                className="form-control"
                                id="latitude_id"
                                name="latitude"
                          
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="latitude_id" className="col-sm-2 control-label">
                             Profile Image
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="file"
                                onChange={handleImageChange}
                                className="form-control"
                                id="latitude_id"
                                name="latitude"
                          
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        </div>
                          <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={UpdateUser}
                              value="Update"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
 )}
    </>
  );
}

export default Edit;
